import { render, staticRenderFns } from "./createUser.vue?vue&type=template&id=5f007952&"
import script from "./createUser.vue?vue&type=script&lang=js&"
export * from "./createUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports